// import Swal from 'sweetalert2'

import { _query } from '../utils/query.js'

export function swalOpt(html, confirmButtonText, cancelButtonText) {
	return {
		// title: '<?= __("Error Message") ?>',
		html: `<div class="modal-body"><div class="error-msg-holder">${html}</div></div>`,
		padding: '0 0 30px',
		focusConfirm: false,
		customClass: {
			container: 'container-class',
			popup: 'popup-class',
			header: 'header-class',
			actions: 'actions-class',
			confirmButton: 'confirm-button-class',
			cancelButton: 'cancel-button-class',
		},
		confirmButtonText,
		cancelButtonText,
		showCancelButton: true,
		// showCancelButton == undefined ? false : showCancelButton,
		allowOutsideClick: false,
		// allowOutsideClick == undefined ? false : allowOutsideClick,
		// showCloseButton: false
		// typeof showCloseButton !== 'undefined' ? showCloseButton : true
		// didOpen: typeof didOpen !== 'undefined' ? didOpen : true
	}
}

export default swalOpt

export function swalOption(
	msg,
	showCloseButton,
	allowOutsideClick,
	didRender,
	confirmButtonText,
	container = 'container-class',
) {
	return {
		html: `<div class="modal-body"><div class="error-msg-holder"> ${msg} </div></div>`,
		padding: '0 0 30px',
		focusConfirm: false,
		customClass: {
			container,
			popup: 'popup-class',
			header: 'header-class',
			confirmButton: 'confirm-button-class',
		},
		allowOutsideClick:
			allowOutsideClick === undefined ? false : allowOutsideClick,
		showCloseButton:
			typeof showCloseButton !== 'undefined' ? showCloseButton : true,
		didRender: didRender ? didRender() : undefined,
		confirmButtonText: confirmButtonText || 'OK',
	}
}

export function swalSlideInOption({
	html,
	showCloseButton,
	allowOutsideClick,
	didOpen,
	confirmButtonText,
	container,
	backdrop = true,
	position = 'center',
}) {
	return {
		html,
		padding: '0 0 30px',
		showClass: {
			popup: 'animate__animated animate__fadeInRight',
		},
		hideClass: {
			popup: 'animate__animated animate__fadeOutRight',
		},
		backdrop,
		position,
		focusConfirm: false,
		customClass: {
			container,
			popup: 'slideInClass',
			header: 'header-class hidden',
			confirmButton: 'confirm-button-class',
			actions: 'hidden',
		},
		allowOutsideClick:
			allowOutsideClick === undefined ? false : allowOutsideClick,
		showCloseButton:
			typeof showCloseButton !== 'undefined' ? showCloseButton : true,
		didRender: didOpen ? didOpen() : undefined,
		confirmButtonText: confirmButtonText || 'OK',
	}
}



function blurForm() {
	const name = _query('#ReferralName')
	name.blur()
}

export function swalBlankOption(
	html,
	showCloseButton,
	allowOutsideClick,
	container = 'container-class',
	didOpenFn = blurForm,
) {
	return {
		html,
		padding: '0 0 30px',
		focusConfirm: true,
		customClass: {
			container,
			popup: 'popupClass',
			header: 'header-class hidden',
			confirmButton: 'confirm-button-class',
			actions: 'hidden',
		},
		allowOutsideClick:
			allowOutsideClick === undefined ? true : allowOutsideClick,
		showCloseButton:
			typeof showCloseButton !== 'undefined' ? showCloseButton : true,
		// didOpen: () => {
		// 	Swal.getConfirmButton().blur()
		// },
		didOpen: didOpenFn ? didOpenFn : undefined,
	}
}
